import React from 'react';
import {AppText, AppErrorText} from './Typography';

interface Option {
  value: string | number;
  label: string;
}

interface AppSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: Option[];
}

const AppSelect: React.FC<AppSelectProps> = ({label, error, options, className = '', ...props}) => {
  // Debug logging for development
  // Debug logging removed for production

  return (
    <div className="w-full">
      {label && <AppText className="block mb-2 font-bold">{label}</AppText>}
      <select
        className={`w-full rounded-xl border bg-white px-4 py-3 text-lg font-normal text-grayText font-zain outline-none transition-all
          ${error ? 'border-red-500' : 'border-gray-200 focus:border-gray-500'}
          placeholder-gray-400
          ${className}`}
        {...props}
      >
        {props.multiple ? null : <option value="">اختر</option>}
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      {error && <AppErrorText className="text-sm mt-2">{error}</AppErrorText>}
    </div>
  );
};

export default AppSelect;
